import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {IPeriod} from '@entities/tieu-chuan/tieu-chuan.model';
import {JhiEventManager} from 'ng-jhipster';
import {TieuChuanService} from '@entities/tieu-chuan/tieu-chuan.service';

@Component({
  selector: 'app-giai-doan-delete-dialog',
  templateUrl: './giai-doan-delete-dialog.component.html',
})
export class GiaiDoanDeleteDialogComponent {
  period: IPeriod;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }
  constructor(
    private dialogRef: MatDialogRef<GiaiDoanDeleteDialogComponent>,
    private eventManager: JhiEventManager,
    private tieuchuanService: TieuChuanService,
  ) {}

  confirmDelete(id: any) {
    this.tieuchuanService.deletePeriod(id).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'tieuChuanDetailModification',
        content: 'TieuChuan',
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-giai-doan-delete-popup',
  template: '',
})
export class GiaiDoanDeletePopupDiaglogComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<GiaiDoanDeleteDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.tieu-chuan.giai-doan-delete-dialog.Xóa giai đoạn_title',
      ),
    );
    this.activatedRoute.data.subscribe(({giaidoan}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(GiaiDoanDeleteDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.period = giaidoan;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }
  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('common.title.Chi tiết quy trình'),
    );
    this.dialogRef = null;
  }
}
